export default __webpack_public_path__ + "static/media/google-QR.28599013.png";